// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"hL-z","carouselContainer":"iL-z"};